export const content = {
  es: {
    langName: "ES",
    nameLabel: "PACO MONTERO",
    heroLines: ["Pensar con claridad.", "Trabajar con intención.", "Vivir con menos."],
    heroKicker: "Ideas sobre estoicismo, negocios y una vida deliberadamente sencilla.",
    heroBody:
      "Una reflexión semanal para líderes, empresarios y personas que quieren tomar mejores decisiones sin convertir su vida en una carrera interminable.",
    formPlaceholder: "Tu correo electrónico",
    formButtonHero: "Recibir las reflexiones",
    formButtonNewsletter: "Suscribirme",
    formSuccess: "Gracias. Revisa tu correo pronto.",
    formError: "No hemos podido suscribirte. Inténtalo de nuevo.",
    formExists: "Ese correo ya está suscrito.",
    formInvalid: "Introduce un correo válido.",

    manifestoTitle: "El éxito no consiste en acumular más",
    manifestoParas: [
      "Construimos empresas para ganar libertad y terminamos siendo propiedad de ellas.",
      "El estoicismo no enseña a resignarse. Enseña a diferenciar aquello que podemos dirigir de aquello que solo podemos aceptar.",
      "Escribo sobre cómo aplicar esa idea a los negocios, el liderazgo y la vida cotidiana.",
    ],

    principlesLabel: "Tres principios",
    principles: [
      {
        name: "Control",
        text: "Dedica tu energía a tus decisiones, tus acciones y tu carácter. El resto no te pertenece.",
      },
      {
        name: "Suficiencia",
        text: "Una empresa sana debe proporcionar libertad, no alimentar indefinidamente el ego de su fundador.",
      },
      {
        name: "Intención",
        text: "El crecimiento solo merece la pena cuando sirve a una vida que realmente quieres vivir.",
      },
    ],

    aboutLabel: "Presentación personal",
    aboutTitle: "Soy Paco Montero",
    aboutParas: [
      "Consultor, empresario tecnológico y estudioso de la relación entre filosofía, estrategia y crecimiento.",
      "Durante años he trabajado ayudando a empresas a crecer. Ahora también exploro una pregunta más importante:",
    ],
    aboutQuote: "¿Cómo podemos crecer profesionalmente sin empobrecer nuestra vida?",

    newsletterLabel: "Newsletter",
    newsletterTitle: "Una idea que puedas utilizar",
    newsletterIntro: "Cada semana recibirás una reflexión breve sobre:",
    newsletterTopics:
      "Decisiones estratégicas · liderazgo · negocios conscientes · minimalismo · libertad personal",
    newsletterFine: "Sin ruido. Sin publicaciones diarias. Sin convertir tu bandeja de entrada en otra obligación.",

    footerLinks: ["Artículos", "Sobre Paco", "LinkedIn", "Privacidad"],
    footerNote: "Negocios con criterio. Vida con intención.",
  },
  en: {
    langName: "EN",
    nameLabel: "PACO MONTERO",
    heroLines: ["Think clearly.", "Work with intention.", "Live with less."],
    heroKicker: "Ideas on stoicism, business and a deliberately simple life.",
    heroBody:
      "A weekly reflection for leaders, founders and anyone who wants to make better decisions without turning their life into an endless race.",
    formPlaceholder: "Your email address",
    formButtonHero: "Get the reflections",
    formButtonNewsletter: "Subscribe",
    formSuccess: "Thank you. Check your inbox soon.",
    formError: "We couldn't subscribe you. Please try again.",
    formExists: "That email is already subscribed.",
    formInvalid: "Please enter a valid email.",

    manifestoTitle: "Success is not about accumulating more",
    manifestoParas: [
      "We build companies to gain freedom and end up owned by them.",
      "Stoicism does not teach resignation. It teaches us to tell apart what we can steer from what we can only accept.",
      "I write about how to apply that idea to business, leadership and everyday life.",
    ],

    principlesLabel: "Three principles",
    principles: [
      {
        name: "Control",
        text: "Spend your energy on your decisions, your actions and your character. The rest is not yours.",
      },
      {
        name: "Enough",
        text: "A healthy company should provide freedom, not endlessly feed its founder's ego.",
      },
      {
        name: "Intention",
        text: "Growth is only worth it when it serves a life you actually want to live.",
      },
    ],

    aboutLabel: "About",
    aboutTitle: "I'm Paco Montero",
    aboutParas: [
      "Consultant, technology entrepreneur and student of the relationship between philosophy, strategy and growth.",
      "For years I've helped companies grow. Now I also explore a more important question:",
    ],
    aboutQuote: "How can we grow professionally without impoverishing our life?",

    newsletterLabel: "Newsletter",
    newsletterTitle: "One idea you can use",
    newsletterIntro: "Every week you'll receive a short reflection on:",
    newsletterTopics:
      "Strategic decisions · leadership · conscious business · minimalism · personal freedom",
    newsletterFine: "No noise. No daily posts. No turning your inbox into another obligation.",

    footerLinks: ["Articles", "About Paco", "LinkedIn", "Privacy"],
    footerNote: "Business with judgment. Life with intention.",
  },
};
